export default {
    isUserLoggedIn: () => {
        return !!localStorage.getItem('loggedIn');
    },
}
